import APIS from "../../constant/EndPoint";
import NACell from "../Reusable/DataTable/NACell";
import SwitchButton from "../Reusable/SwitchButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import EditIcon from "../../Icons/EditIcon";
import DataTable from "../Reusable/DataTable";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import Button from "../Reusable/Button";
import Modal from "../Reusable/Modal";
import SyncContact from "./SyncContact";
import usePermission from "../../customHooks/usePermission";
import { useNavigate } from "react-router-dom";
import { MapPin } from "lucide-react";



const StaffList = (props: any) => {
  const { handleIsActive, profile } = props;
  const [openSyncContactPopUp, setOpenSyncContactPopup] = useState(false);
  const navigate = useNavigate();
  const canEditStaff = usePermission({
    allowedPermissions: ["can_update_staff"],
  });
  const handleRowClick = (row: any) => {
    if (!canEditStaff) return;
    navigate(`edit/${row?.original?.id}`);
  };
  const defaultColumns: any = [
    {
      header: "Full Name",
      accessorKey: "full_name",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "user.email",
      cell: NACell,
    },
    {
      header: "Mobile Number",
      accessorKey: "user.mobile_number",
      cell: NACell,
    },
    {
      header: "CheckIn Grace",
      accessorKey: "checkin_grace",
      cell: NACell,
    },
    {
      header: "CheckOut Grace",
      accessorKey: "checkout_grace",
      cell: NACell,
    },
   {
      header: "Location",
      cell: ({ row }) => {
        const lat = row.original?.latitude;
        const lng = row.original?.longitude;

        if (!lat || !lng) return <span className="text-gray-400 text-xs">No Data</span>;

        return (
          <div 
            onClick={(e) => e.stopPropagation()} 
            className={tw`flex items-center w-full`}
          >
            <a
              href={`https://www.google.com/maps?q=${lat},${lng}`}
              target="_blank"
              rel="noreferrer"
              
            >
       <MapPin size={16} className={tw`text-red-500 group-hover:text-red-700 items-center`} />
                
            </a>
          </div>
        );
      },
    },
    {
      header: "Overtime",
      accessorKey: "is_overtime_allowed",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_staff"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.STAFF_INFO}
        queryKey={"staff-list"}
        params={{}}
        columns={defaultColumns}
        tableName={"staff-list"}
        onRowClick={handleRowClick}
        addNewPagePath={"create"}
      />
      <Modal
        title={"Sync Contact"}
        isOpen={openSyncContactPopUp}
        setIsOpen={setOpenSyncContactPopup}
      >
        <SyncContact setOpenSyncContactPopup={setOpenSyncContactPopup} />
      </Modal>
    </>
  );
};

export default StaffList;
